export const exampleMarkdown = `# Markdown to Word Example

## Features

This is a **powerful** Markdown to Word tool that supports the following features:

- **Bold text** and *italic text*
- Multi-level headings
- Ordered and unordered lists
- \`Code snippets\` and code blocks
- Blockquotes

### Code Example

\`\`\`javascript
function hello() {
  console.log("Hello, World!");
}
\`\`\`

> This is a blockquote example
> It can contain multiple lines of content

### List Example

1. First item
2. Second item
3. Third item

- Unordered list item
- Another item
- Last item

**Start using it!** Upload your Markdown file or paste content directly.`
